// Borrowed from https://usehooks.com ♥️
import { useEffect, useState } from 'react';

export function useWindowSize(): { height: number | undefined; width: number | undefined } {
    const isClient = typeof window === 'object';

    function getSize(): { height: number | undefined; width: number | undefined } {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined,
        };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useEffect((): any => {
        if (!isClient) {
            return false;
        }

        function handleResize(): void {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);

        return (): void => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return windowSize;
}
